import { createApp } from 'vue';
import Toast from './toast.vue';

const showToast = (msg: string, options = { duration: 2000 }) => {
  const { duration } = options;
  const div = document.createElement('div');
  const componentInstance = createApp(Toast, {
    show: true,
    msg,
    duration
  });

  componentInstance.mount(div);
  document.body.appendChild(div);

  let timer = undefined;
  let destroyed = false;
  clearTimeout(timer);
  const destroy = () => {
    if (destroyed) return;
    componentInstance.unmount();
    document.body.removeChild(div);
    destroyed = true;
  };
  timer = setTimeout(destroy, duration);
  return { destroy };
};

export default showToast;
